import React from 'react';

import { Route, Switch } from 'react-router-dom';

import AppRoutes from 'components/Routes';
import AppRoute from 'components/Routes/AppRoute';
import AuthRoutes from 'components/Routes/Auth';
import AuthRoute from 'components/Routes/AuthRoute';
import CustomRedirect from 'components/shared/CustomRedirect';
import DeletedOrOnlyGuestErrorScreen from 'components/shared/DeletedOrOnlyGuestErrorScreen';
import ErrorScreen from 'components/shared/ErrorScreen';
import {
  ACC_ID,
  AUTH_PATH,
  ROOT_PATH,
  LOGIN_PATH,
  UNAUTHORIZED_BLOCKED_PATH,
  UNAUTHORIZED_DELETED_PATH,
} from 'constants/routes';
import { useAppUpdate } from 'hooks/useAppUpdate';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useLogoutAs } from 'hooks/useLogoutAs';

import Swagger from '../Swagger';

function Account() {
  useDocumentTitle({ title: 'Safari Portal' });
  useAppUpdate();
  useLogoutAs();

  return (
    <Switch>
      <Route path={ROOT_PATH} component={() => <CustomRedirect to={LOGIN_PATH} />} exact />
      <AuthRoute path={AUTH_PATH} children={<AuthRoutes />} />
      <AppRoute path={ACC_ID} children={<AppRoutes />} />
      <Route path={UNAUTHORIZED_BLOCKED_PATH} render={() => <ErrorScreen status="blocked" />} exact />
      <Route path={UNAUTHORIZED_DELETED_PATH} render={() => <DeletedOrOnlyGuestErrorScreen />} exact />
      <Route path="/docs/external_api/v1" render={() => <Swagger />} />
      <Route component={() => <ErrorScreen status="404" />} />
    </Switch>
  );
}

export default Account;
